// Builds image and favicon URLs from stored paths. Logos and favicons live
// under /uploads on the API; any other relative path is a frontend asset.
// Only https, http while running locally, and raster base64 data URLs pass
// through; every other scheme returns null so it never reaches src or href.

export function isLocalHost(hostname) {
  return hostname === 'localhost'
    || hostname === '127.0.0.1'
    || /^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname)
    || /^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname);
}

// Hosted, the site proxies /api and /uploads to the API, so it is its own origin.
export function apiOrigin() {
  const { protocol, hostname, origin } = window.location;
  if (!isLocalHost(hostname)) return origin;
  if (process.env.REACT_APP_API_URL) {
    try {
      return new URL(process.env.REACT_APP_API_URL, origin).origin;
    } catch (error) {
      // Falls through to the default local API port.
    }
  }
  return `${protocol}//${hostname}:5000`;
}

const RASTER_DATA_URL = /^data:image\/(png|jpeg|webp|gif);base64,/i;
const ANY_SCHEME = /^[a-z][a-z0-9+.-]*:/i;

export function assetUrl(path) {
  if (typeof path !== 'string' || path === '') return null;
  if (/^https:\/\//i.test(path)) return path;
  if (/^http:\/\//i.test(path)) return isLocalHost(window.location.hostname) ? path : null;
  if (RASTER_DATA_URL.test(path)) return path;
  if (path.startsWith('//') || ANY_SCHEME.test(path)) return null;
  if (path.startsWith('uploads/') || path.startsWith('/uploads/')) {
    return `${apiOrigin()}/${path.replace(/^\//, '')}`;
  }
  return `${window.location.origin}${path.startsWith('/') ? '' : '/'}${path}`;
}
